<template>
  <modal-v2 relaxed-header :show="show" :on-close="closeModal">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header-v2
        :header-title="$t('INTEGRATION_SETTINGS.CLICK2CALL.SETTINGS.TITLE')"
        :header-content="$t('INTEGRATION_SETTINGS.CLICK2CALL.SETTINGS.DESC')"
      />
      <click2-call-settings
        :has-hook="hasHook"
        @cancel="closeModal"
        @saved="$emit('saved')"
      />
    </div>
  </modal-v2>
</template>

<script>
import Click2CallSettings from './Settings.vue';

export default {
  name: 'Click2CallSettingsModal',
  components: { Click2CallSettings },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    hasHook: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
